

const TwoLabel = ({ one, two }) => {
    return (
        <>
            <span>{one}</span>
            <span>{two}</span>
        </>
    );
};

export default TwoLabel;